export const NFT_REPAIR_LOG_LIST_REQUEST = 'NFT_REPAIR_LOG_LIST_REQUEST';
